function sorasitaInit ($) {

'use strict';
console.log($.fn.jquery);

var initialized = false;

var $window = $(window);
var $root = $('#root');
var $header = $('#header');

var windowWidth = window.innerWidth;
var breakPoint = {
	tablet: 768,
	desktop: 1024
}

/**
 * Global Navigation Shadow
 */
$window.scroll(function () {
	var scrollTop = $window.scrollTop();
	if( scrollTop > 0) {
		$header.addClass('shadow');
	} else {
		$header.removeClass('shadow');
	}
});

/**
 * Global Navigation Toggle
 */
// var $navigation = $('#global-nav');
var $navToggleBtn =  $('#navToggleBtn');

$navToggleBtn.click(function (e) {
	e.preventDefault();

	$root.toggleClass('showingNav');
});

/**
 * Global Navigation Accordion
 */
var $navAccordionLink = $('ul.global-nav > li.menu-item.isAccordion > a');
var navAccordionToggleClass = 'isOpened';

function navAccordionCallback(e) {
	e.preventDefault();

	var $this = $(this);
	var subMenu = this.nextElementSibling;

	if ( $this.hasClass(navAccordionToggleClass) ) {
		$this.removeClass(navAccordionToggleClass);
		subMenu.style.maxHeight = null;
	} else {
		var maxHeight = subMenu.scrollHeight;

		$this.addClass(navAccordionToggleClass);
		subMenu.style.maxHeight = maxHeight + 'px';
	}
}

/**
 * Smooth scrolling
 */
$('a[href*="#"]:not([href="#"])').click(function() {
	if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
		var target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		if (target.length) {
			$('html, body').animate({
				scrollTop: target.offset().top
			}, 1000);
			return false;
		}
	}
});

/**
 * Tel Link Modification
 */
var telLinks = document.querySelectorAll('.telLink');
if (telLinks.length > 0) {
	for(var i=0; i < telLinks.length; i++) {
		var href = telLinks[i].getAttribute('href');
		href = href.replace('+810', '+81');
		telLinks[i].setAttribute('href', href);
	}
	/*telLinks.forEach(function (link) {
		var href = link.getAttribute('href');
		href = href.replace('+810', '+81');
		link.setAttribute('href', href);
	});*/
}

/**
 * To Page Top & Mobile Reservation
 */
var $toPageTopButton = $('#toPageTop');
// var $mobileReservation = $('#mobileReservation');
var windowHeight = $window.height();
//var documentHeight = $(document).height();
//var revealPoint = (documentHeight-windowHeight)/2;
//var revealPoint = 1000;

if( windowWidth < 1024 ) {
	$window.on('scroll', function () {
		var scrollTop = $window.scrollTop();

		if ( scrollTop > 1000) {
			$toPageTopButton.addClass('showed');
			// $mobileReservation.addClass('showed');
		} else {
			$toPageTopButton.removeClass('showed');
			// $mobileReservation.removeClass('showed');
		}

		/* if (scrollTop > 1500) {
			
		} else {
			
		} */
	});
}

/**
 * Header Background on Front Page
 */
if( $root.hasClass('frontpage') ) {
	$window.scroll(function () {
		var scrollTop = $window.scrollTop();
		if( scrollTop > 0) {
			$root.removeClass('frontpage');
		} else {
			$root.addClass('frontpage');
		}
	});
}

/**
 * Top Hero
 */
var $topHero = $('#top-hero-slick');
if ($topHero.length > 0) {
	$topHero.slick({
		arrows: false,
		autoplay: true,
		autoplaySpeed: 4500,
		dots: true,
		fade: true,
		infinite: true,
		pauseOnHover: false,
		speed: 1500,
	});
}

/**
 * Store Gallery
 */
var $storeGallery = $('section.store-gallery > .gallery');
var galleryFeed = (windowWidth < breakPoint.tablet) ? (2/3*100) : 20;

function loopStoreGallery ($gallery) {
	$gallery.stop().animate({
		left: -galleryFeed + '%',
	}, 5000, 'linear', function () {
		$(this).css({left:0})
			.children('figure:last')
			.after( $('figure:first', this) );
			loopStoreGallery($gallery);
	});
}
if ($storeGallery.length > 0) loopStoreGallery($storeGallery);

/**
 * Recommendation Slick
 */
var $recommendations = $('#recommendations');
var $recommendationPics = $('#recommendation-pics > picture');

if($recommendations.length > 0){
	$recommendations.slick({
		arrows: false,
		autoplay: true,
		autoplaySpeed: 5000,
		dots: true,
		fade: true,
		infinite: true,
		speed: 1500,
		// swipe: false,
	});

	$recommendations.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
		$recommendationPics.removeClass('viewed');
		$recommendationPics.eq(nextSlide).addClass('viewed');
	});
}

/**
 * FAQ Tab
 */
var $faqTabButtons = $('button.faq-tab');
var $faqTabs = $('.faq-wrap');
var faqTabOffsetTop = $('#faqs').offset().top;
if ( $faqTabButtons.length > 0 ) {
	$faqTabButtons.click(function (e) {
		e.preventDefault();

		var $this = $(this);
		var target = $this.data('target');

		// Remove current "active"
		$faqTabButtons.removeClass('active');
		$faqTabs.removeClass('active');

		// Add "active"
		$faqTabButtons.eq(target).addClass('active');
		$faqTabButtons.eq(target+3).addClass('active');
		$faqTabs.eq(target).addClass('active');

		if ( $this.data('scroll') ) {
			$('html, body').animate({
				scrollTop: faqTabOffsetTop
			}, 500);
		}

	}); // .click()
}

/**
 * FAQ Acoordion
 */
var qaButtons = $('button.faq-q');
if( qaButtons.length > 0) {

	// Click Event
	qaButtons.click( function(e) {
		e.preventDefault();

		var $this = $(this);
		var next = this.nextElementSibling;
		
		if ($this.hasClass('opened')) {
			$this.removeClass('opened');
			next.classList.remove('opened');
			next.style.maxHeight = null;
		} else {
			var scrollHeight = next.scrollHeight;
			// console.log(scrollHeight);
			$this.addClass('opened');
			next.classList.add('opened');
			next.style.maxHeight = scrollHeight+'px';
		}
	});

	// Open targeted Q&A
	var hashValue = window.location.hash.substr(1);
	if (hashValue) {
		var targetQuestion = document.getElementById(hashValue).nextElementSibling;
		$(targetQuestion).trigger('click');
	}
}

/**
 * Store Lightbox
 * @link https://simplelightbox.com/
 */
var $facilityImages = $('a.store-facility');
var $storeMenuDrinkImages = $('a.store-menu-drink');
if (  $facilityImages.length > 0 && windowWidth < breakPoint.tablet ) {

	// Facility
	$facilityImages.simpleLightbox({
		history: false,
	});

	// Drink menu
	if ( $storeMenuDrinkImages.length > 0 ) {
		$storeMenuDrinkImages.simpleLightbox({
			history: false,
		});
	}

} else {
	$facilityImages.click(function (e) {
		e.preventDefault();
	});
}

/**
 * Resize Event
 */
function windowResize() {
	var preWindowHeight = windowWidth;
	windowWidth = window.innerWidth;

	// Not so big window resizing
	if ( initialized ) {
		if (
			(preWindowHeight >= breakPoint.desktop && windowWidth >= breakPoint.desktop) ||
			(preWindowHeight < breakPoint.desktop && windowWidth < breakPoint.desktop)
		) return;
	}
	
	// Mobile
	if ( windowWidth < breakPoint.desktop ) {
		$navAccordionLink.on('click', navAccordionCallback);
		console.log('ON');
	}
	// Desktop
	else {
		$navAccordionLink.off('click', navAccordionCallback);
		console.log('OFF');
	}

	initialized = true;
}
$window.resize( windowResize );
windowResize();

}